<template>
  <div class="auto-save-component"></div>
</template>

<!--suppress JSUnusedGlobalSymbols -->
<script>
export default {
  name: 'HotKeysSave',
  props: [
    'messages',
    'callback'
  ],
  data () {
    return {}
  },
  mounted () {
    const platform = navigator?.userAgentData?.platform || navigator?.platform
    const isMac = /(Mac|iPhone|iPod|iPad)/i.test(platform)
    this.callback.invokeMethodAsync('SetMac', isMac)

    document.addEventListener('keydown', this.ctrlSavePressDetect)
  },
  unmounted () {
    document.removeEventListener('keydown', this.ctrlSavePressDetect)
  },
  methods: {
    ctrlSavePressDetect (e) {
      if (!('key' in e)) {
        return
      }

      if (e.keyCode !== 83 || e.ctrlKey !== true) {
        return
      }

      document.activeElement.blur()
      e.preventDefault()
      e.stopPropagation()

      const self = this
      setTimeout(() => {
        self.callback.invokeMethodAsync('HotKeysSave', e.altKey === true)
      }, 50)
    }
  }
}
</script>
